const INITIAL_ICON_STYLES = [
	'bg-stone-100 text-stone-800',
	'bg-stone-200 text-stone-900',
	'bg-stone-100 text-stone-900',
	'bg-stone-200 text-stone-800',
	'bg-stone-100 text-stone-700',
] as const;

export const getEntityInitials = (name: string) => {
	const parts = name.trim().split(/\s+/).filter(Boolean);
	if (parts.length >= 2) {
		return `${parts[0]!.slice(0, 1)}${parts[1]!.slice(0, 1)}`.toUpperCase();
	}
	return name.slice(0, 2).toUpperCase() || '—';
};

export const getEntityIconStyleForIndex = (index: number) =>
	INITIAL_ICON_STYLES[index % INITIAL_ICON_STYLES.length];
